module.exports = {"button.check.availability":"Check availability"}


//////////////////
// WEBPACK FOOTER
// ./src/static/locales/ca.json
// module id = 331
// module chunks = 0